import Vue from "vue";
import MessageComponent from "./message.vue";

const MessageConstructor = Vue.extend(MessageComponent);

const instances = [];
let seed = 1;
let verticalOffset = 50;

const Message = (options = {}) => {
  if (typeof options === "string") {
    options = { message: options };
  }

  const id = `message_${seed++}`;
  const instance = new MessageConstructor({
    propsData: {
      ...options,
    },
  });

  // 先关闭所有现有 message
  instances.forEach((inst) => {
    if (inst && typeof inst.close === "function") {
      inst.close(); // 触发组件的 close 事件
    }
  });

  instance.$mount();
  document.body.appendChild(instance.$el);

  instance.$on("close", () => {
    closeMessage(id);
  });

  instance._id = id;
  instance.$el.style.top = verticalOffset + "px";
  verticalOffset += instance.$el.offsetHeight + 16;
  instances.push(instance);

  return instance;
};

function closeMessage(id) {
  const index = instances.findIndex((inst) => inst._id === id);
  if (index === -1) return;

  const removed = instances.splice(index, 1)[0];
  verticalOffset -= removed.$el.offsetHeight + 16;
  document.body.removeChild(removed.$el);

  // 更新后面 message 的位置
  for (let i = index; i < instances.length; i++) {
    const el = instances[i].$el;
    const top = parseInt(el.style.top) - removed.$el.offsetHeight - 16;
    el.style.top = top + "px";
  }
}

export default Message;



// WEBPACK FOOTER //
// ./src/components/message/Message.js